import React from 'react';
import { Checkbox, Justify } from 'tea-component';
import ScoreFilterSelect from '../../components/ScoreFilterSelect';
import BubbleCommon, {
  gameStoreAlertCountriesTips,
  gameStoreCollectedCountriesTips,
} from '@/pages/opinion/components/BubbleCommon';
import SvgIcon from '@/pages/home/components/SvgIcon';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';

import { popularList } from '@/pages/opinion/components/FilterCommon/constants/regionAndLanguage';
import { getLocale, useIntl } from 'umi';
import { buriedBtnPoint } from '@/pages/opinion/operationLog/buriedPoint';

const radioOptions = [
  {
    value: 'global',
    text: 'Global',
    textCN: '全部',
  },
];

export default function TopFilterInfo({
  regionOptions,
  tableSelectable,
  setTableSelectable,
  regionValue,
  setRegionValue,
  useFilterRegion,
  setUseFilterRegion,
  scoreFilterChange,
}: any) {
  const { formatMessage } = useIntl();
  return (
    <>
      <Justify
        className="gamestore-justify"
        left={
          <>
            <ScoreFilterSelect scoreFilterChange={scoreFilterChange} />
            <BubbleCommon
              placement="top"
              showIcon={false}
              tipsMap={gameStoreAlertCountriesTips}
            >
              <div className="gamestore-table-checkbox">
                <Checkbox
                  name="alertCountry"
                  value={tableSelectable}
                  onChange={() => {
                    buriedBtnPoint('G_Alter');
                    setTableSelectable(!tableSelectable);
                  }}
                >
                  {formatMessage({ id: 'Alert Countries' })}
                </Checkbox>
              </div>
            </BubbleCommon>

            <div className="gamestore-table-setting">
              <BubbleCommon
                showIcon={false}
                placement="top"
                tipsMap={gameStoreCollectedCountriesTips}
              >
                <div className="gamestore-table-checkbox">
                  <Checkbox
                    value={useFilterRegion}
                    onChange={() => {
                      setUseFilterRegion(!useFilterRegion);
                      buriedBtnPoint('G_Collected');
                    }}
                  >
                    {formatMessage({ id: 'Collected Countries' })}
                  </Checkbox>
                </div>
              </BubbleCommon>
              <div className="gamestore-table-setting-icon">
                <SvgIcon type="set-up" />
                {/* 复杂筛选器占位示意 */}
                <NewRegionSelect
                  className="gamestore-table-setting-dropbox"
                  value={regionValue}
                  options={regionOptions}
                  popularList={popularList}
                  locale={getLocale()}
                  radioOptions={radioOptions}
                  closeOnScroll={true}
                  onClick={() => {
                    buriedBtnPoint('G_Setting');
                  }}
                  onCloseReginSelect={(value) => {
                    setRegionValue(value);
                  }}
                />
              </div>
            </div>
          </>
        }
      />
    </>
  );
}
